import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { useStore } from 'vuex';
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import { getMenuList } from '@/router/menu-factory';
import MenuItem from '@/layout/components/sidebar/menu-bar/MenuItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MenuBar',
    setup: function (__props) {
        var store = useStore();
        var route = useRoute();
        onMounted(function () {
            activeMenu(route);
        });
        // region TODO 监听选中菜单
        var defaultActive = ref('');
        onBeforeRouteUpdate(function (e) {
            activeMenu(e);
        });
        function activeMenu(route) {
            defaultActive.value = ((route === null || route === void 0 ? void 0 : route.meta.activeMenu) || route.name);
        }
        // endregion
        // 缩放状态
        var collapse = computed(function () { return store.getters['layout/collapse']; });
        // 菜单列表
        var menuList = computed(getMenuList);
        return function (_ctx, _cache) {
            var _component_el_menu = _resolveComponent("el-menu");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_el_menu, {
                    collapse: _unref(collapse),
                    "default-active": defaultActive.value
                }, {
                    default: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), function (menu) {
                            return (_openBlock(), _createBlock(MenuItem, {
                                key: menu.name,
                                menu: menu
                            }, null, 8, ["menu"]));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["collapse", "default-active"])
            ]));
        };
    }
});
